import React, { useEffect } from "react";
export const RedirectToCP: React.FC = () => {
  useEffect(() => {
    window.location.href = "/cp";
  }, []);

  return null;
};
